"use client";

export interface NewVisitCTAProps {
  onStartVisit: () => void;
  isProcessing?: boolean;
}

function OrDivider() {
  return (
    <div className="flex items-center gap-2.5 w-full">
      <div className="flex-1 h-px bg-border" />
      <span className="font-sans font-semibold text-xs leading-4 tracking-[0.5px] uppercase text-text-100">
        or
      </span>
      <div className="flex-1 h-px bg-border" />
    </div>
  );
}

function NewVisitChevron() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M6 4L10 8L6 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function KinsaNewVisitCTA({
  onStartVisit,
  isProcessing = false,
}: NewVisitCTAProps) {
  return (
    <div className="flex flex-col items-center gap-4">
      <OrDivider />
      <button
        type="button"
        onClick={onStartVisit}
        disabled={isProcessing}
        className="w-full h-[44px] rounded-[99px] bg-primary font-sans font-medium text-[15px] leading-[22px] tracking-[1.5px] uppercase text-on-primary disabled:opacity-50 transition-opacity flex items-center justify-center gap-2"
      >
        {isProcessing ? (
          <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
        ) : (
          <>
            new visit
            <NewVisitChevron />
          </>
        )}
      </button>
    </div>
  );
}
